export default [
	{
		name: 'home',
		icon: 'home',
		title: 'Inicio',
		url: '/inicio',
		mostrar: false
	}
];
